module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2ffafb13c4cfe8ce811bbe1b4a0c2f94.png";